import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте\\nвариант ответа'
    ),
    qrTitle1: getDefaultValue(searchParams.get('qrTitle1'), 'Telegram'),
    qrCode1: searchParams.get('qrCode1'),
    qrTitle2: getDefaultValue(searchParams.get('qrTitle2'), 'WhatsApp'),
    qrCode2: searchParams.get('qrCode2'),

    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,

    titleFontSize: searchParams.get('titleFontSize') || '4.4',
    sizeQR: searchParams.get('sizeQR') || '23',
    paddingQR: searchParams.get('paddingQR') || '0',

    questionFontSize: searchParams.get('questionFontSize') || '4.375',
    answerFontSize: searchParams.get('answerFontSize') || '4.2',
    varNumFontSize: searchParams.get('varNumFontSize') || '3.73',

    winnerFontSize: searchParams.get('winnerFontSize') || '6.25',

    marginTopQuiz: searchParams.get('marginTopQuiz') || '0',

    winnerWord: searchParams.get('winnerWord') || 'Победитель',

    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    // phoneNumber,
    // socials: searchParams.get('socials'),
  };
};
